// Elements
  const efDrawer   = document.getElementById('ef-drawer');
  const efMenuBtn  = document.querySelector('.ef-menu-toggle');
  const efCloseBtn = document.querySelector('.ef-drawer__close');

  // Open (fade in + lock scroll)
  function efOpenDrawer() {
    if (!efDrawer) return;
    efDrawer.hidden = false;               // ensure it's renderable
    requestAnimationFrame(() => {
      efDrawer.classList.add('active');    // triggers CSS fade
      if (efMenuBtn) efMenuBtn.setAttribute('aria-expanded','true');
    });
    document.body.style.overflow = 'hidden';
  }

  // Close (fade out + restore scroll)
  function efCloseDrawer() {
    if (!efDrawer) return;
    efDrawer.classList.remove('active');
    if (efMenuBtn) efMenuBtn.setAttribute('aria-expanded','false');
    // Wait for fade-out to finish before hiding
    setTimeout(() => { efDrawer.hidden = true; }, 200);
    document.body.style.overflow = '';
  }

  // Bind
  if (efMenuBtn)  efMenuBtn.addEventListener('click', efOpenDrawer);
  if (efCloseBtn) efCloseBtn.addEventListener('click', efCloseDrawer);
  window.addEventListener('keydown', e => { if (e.key === 'Escape') efCloseDrawer(); });

  // Desktop "Community" aria feedback (optional polish)
  const efDeskToggle = document.querySelector('.ef-nav__toggle');
  const efDeskSub    = document.getElementById('ef-sub-community');
  if (efDeskToggle && efDeskSub){
    const show = () => efDeskToggle.setAttribute('aria-expanded','true');
    const hide = () => efDeskToggle.setAttribute('aria-expanded','false');
    efDeskToggle.addEventListener('focus', show);
    efDeskToggle.addEventListener('blur', hide);
    efDeskSub.addEventListener('mouseenter', show);
    efDeskSub.addEventListener('mouseleave', hide);
  }

  // Mobile submenu toggles (Community)
  document.querySelectorAll('.ef-drawer__toggle').forEach(btn=>{
    btn.addEventListener('click', () => {
      const id = btn.getAttribute('aria-controls');
      const panel = id ? document.getElementById(id) : null;
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      if (panel) panel.hidden = expanded;
    });
  });